// Conversão percent (UI) ↔ fração (backend manda decimais como string 0–1).

/** "25" → "0.25". Inválido → "0" (fallback p/ campos obrigatórios). */
export function pctToFraction(pct: string): string {
  const n = Number(pct);
  return Number.isFinite(n) ? String(n / 100) : "0";
}

/** "25" → "0.25". Vazio/inválido → null (p/ campos opcionais). */
export function pctToFractionOrNull(pct: string): string | null {
  const t = pct.trim();
  if (t === "") return null;
  const n = Number(t);
  return Number.isFinite(n) ? String(n / 100) : null;
}

/** Fração do backend ("0.85") → percent ("85"). Vazio/inválido → null. */
export function fractionToPct(fraction: string | null | undefined): string | null {
  if (fraction == null || fraction === "") return null;
  const n = Number(fraction);
  return Number.isFinite(n) ? String(n * 100) : null;
}
